import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';

export default createStore({
  state: {
    isLoggedIn: false,    
    isFirstLoad: true,
    user: null,
    isAuthenticated: false,
    roleToken: '', // Default role
    tokens: {
      clavePendiente: null,
      tokenFinal: null,
    },    
    genero: null,
  },
  mutations: {
    setGenero(state, genero) {
      state.genero = genero;
    },
    setSelectedCameraId(state, deviceId) {
      state.selectedCameraId = deviceId;
    },
    setTokens(state, tokens) {
      state.tokens = tokens;
    },
    clearState(state) {
      state.tokens = {
        clavePendiente: null,
        tokenFinal: null,
      };
      state.isFirstLoad = true;
    },
    setLoginState(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },    
    setUser(state, userData) {
      state.user = userData;
      state.isAuthenticated = true;
      state.isLoggedIn = true; // Asegura que esto también se establezca
      state.roleToken = userData.role; // Set user role
    },
    clearUser(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.isLoggedIn = false; // Actualiza isLoggedIn aquí
      state.roleToken = ''; // Reset role to default
      state.genero = null;
    },
  },
  actions: {
    login({ commit }, user) {
      commit('setUser', user);
      commit('setLoginState', true); // Asegúrate de que también se establece isLoggedIn
      // this.$router.push('/dashboard');
    },
    logout({ commit }) {
      commit('clearUser'); // Limpia el usuario y otros estados relevantes
      commit('setLoginState', false); // Establece el estado de inicio de sesión como falso
      // this.$router.push('/'); // Redirige al usuario a la página de inicio de sesión
    },    
    async generateTokens({ commit }) {
      try {
        const response = await axios.post('/api/registros/generar-tokens');
        const tokens = {
          clavePendiente: response.data.data.clave_pendiente,
          tokenFinal: response.data.data.token_final,
        };
        commit('setTokens', tokens);
      } catch (error) {
        console.error('Error al generar tokens:', error);
        throw error;
      }
    },
    
    clearData({ commit }) {
      commit('clearState');
    },
  },  
  plugins: [
    createPersistedState({
      paths: ['tokens','isLoggedIn', 'user', 'isAuthenticated', 'roleToken'], // Agrega 'roleToken' aquí
    }),
  ],
  
});
